import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import { routes } from "./routes";
import { AuthRequired } from "./guards/AuthRequired";
import { Layout } from "./components/Layout";
import ErrorPage from "./pages/ErrorPage";
import LoginPage from "./pages/LoginPage";
import AccountsPage from "./pages/AccountsPage";

// Arbre de routes en configuration objet (createBrowserRouter), façon Milo/OneToOne.
// La hiérarchie encode la protection : AuthRequired (guard) -> Layout (shell) -> pages.
// Le guard est AU-DESSUS du Layout car le shell déclenche un appel authentifié (api.me)
// dès son montage : on valide l'auth avant de monter le shell.
const router = createBrowserRouter([
  {
    errorElement: <ErrorPage />,
    children: [
      { path: routes.login(), element: <LoginPage /> },
      {
        element: <AuthRequired />,
        children: [
          {
            element: <Layout />,
            children: [
              { path: routes.home(), element: <AccountsPage /> },
            ],
          },
        ],
      },
      { path: "*", element: <Navigate to={routes.home()} replace /> },
    ],
  },
]);

export default function App() {
  return <RouterProvider router={router} />;
}
